import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  buttonLink: {
    marginRight: 20,
    marginTop: 40,
    marginBottom: 30,
    textTransform: 'none',
  },
  nameField: {
    marginLeft: 50,
    marginTop: 30,
  },
  infoTooltipMargin: {
    marginTop: 'auto',
  },
  numberInputHeight: {
    height: '100%',
  },
  infoBackground: {
    background: '#ECEAEA',
  },
}))

export default useStyles
